module.exports = __webpack_public_path__ + "static/teal-wave-bg-new-1d96dd5aac3d5962b80e2b4665faa12e.png";